import { ABTestGroup, UserPermissionStatus } from 'common-types';
import { StateCreator } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { ILocalStorageStore } from './types';

export const localStorageSlice: StateCreator<ILocalStorageStore, [], [['zustand/persist', ILocalStorageStore], ...[]]> =
  persist(
    (set) => ({
      userPermission: UserPermissionStatus.LOGGED_OUT,
      isDevModeActive: true,
      token: '',
      userServiceToken: '',
      userId: null as string | null,
      isUserLoggedIn: null as boolean | null,
      domain: '',
      hasSeenOnboarding: false,
      isReviewModalShown: false,
      isModalAlreadyShown: false,
      cancelFlowABTestGroup: null as ABTestGroup | null,
      updateCancelFlowABTestGroup: (abTestGroup) => set({ cancelFlowABTestGroup: abTestGroup }),
      updateIsModalAlreadyShown: (isModalAlreadyShown) => set({ isModalAlreadyShown }),
      setIsReviewModalShown: (isReviewModalShown) => set({ isReviewModalShown }),
      setUserPermission: (userPermission) => set({ userPermission }),
      setIsDevModeActive: (isDevModeActive) => set({ isDevModeActive }),
      setToken: (token) => set({ token }),
      setUserServiceToken: (userServiceToken) => set({ userServiceToken }),
      setUserId: (userId) => set({ userId }),
      setIsUserLoggedIn: (isUserLoggedIn) => set({ isUserLoggedIn }),
      setDomain: (domain) => set({ domain }),
      setHasSeenOnboarding: (hasSeenOnboarding) => set({ hasSeenOnboarding }),
      logout: (): void => {
        // @ts-ignore
        window.zE?.('messenger', 'logoutUser');

        set({
          userPermission: UserPermissionStatus.LOGGED_OUT,
          token: '',
          userServiceToken: '',
          userId: null,
          domain: '',
          isUserLoggedIn: null,
        });

        localStorage.removeItem('app-local-storage');
      },
    }),
    {
      name: 'app-local-storage',
      storage: createJSONStorage(() => localStorage),
    },
  );
